import { useIntl } from 'react-intl';

import { useMountToHtmlElement } from '@post-office/components--post-office-team';

import { Text } from '@atlaskit/primitives/compiled';

import { messages } from './messages';

import { type JSX } from 'react/jsx-runtime';

import { SpotlightStepCount } from '@atlaskit/spotlight/step-count';

import { SpotlightSecondaryAction } from '@atlaskit/spotlight/secondary-action';

import { SpotlightPrimaryAction } from '@atlaskit/spotlight/primary-action';

import { SpotlightFooter } from '@atlaskit/spotlight/footer';

import { SpotlightCard } from '@atlaskit/spotlight/card';

import { SpotlightBody } from '@atlaskit/spotlight/body';

import { SpotlightActions } from '@atlaskit/spotlight/actions';

import { PopoverTarget } from '@atlaskit/spotlight/popover-target';

import { PopoverProvider } from '@atlaskit/spotlight/popover-provider';

import { PopoverContent } from '@atlaskit/spotlight/popover-content';

const FILTER_SPOTLIGHT_TARGET =
	'[data-testid="jql-builder-with-ai.ui.filters.filter-refinement.editor-anchor"]';

export const FilterSpotlight = ({
	onNext,
	onDismiss,
	isVisible = true,
}: {
	onNext: () => void;
	onDismiss: (isTourCompleted?: boolean) => void;
	isVisible?: boolean;
}): JSX.Element => {
	const { formatMessage } = useIntl();
	const renderInline = useMountToHtmlElement({
		selectors: FILTER_SPOTLIGHT_TARGET,
		as: 'portal',
		position: 'inside',
	});

	return (
		<div>
			{renderInline(
				<PopoverProvider>
					<PopoverTarget>
						<div />
					</PopoverTarget>
					<PopoverContent
						dismiss={() => onDismiss()}
						placement="bottom-end"
						isVisible={isVisible}
						testId="filter-spotlight--dialog"
					>
						<SpotlightCard>
							<SpotlightBody>
								<Text>{formatMessage(messages.filterSpotlightMessage)}</Text>
							</SpotlightBody>
							<SpotlightFooter>
								<SpotlightStepCount>1/2</SpotlightStepCount>
								<SpotlightActions>
									<SpotlightSecondaryAction onClick={() => onDismiss()}>
										{formatMessage(messages.dismissButton)}
									</SpotlightSecondaryAction>
									<SpotlightPrimaryAction onClick={onNext}>
										{formatMessage(messages.nextButton)}
									</SpotlightPrimaryAction>
								</SpotlightActions>
							</SpotlightFooter>
						</SpotlightCard>
					</PopoverContent>
				</PopoverProvider>,
			)}
		</div>
	);
};
